import { render, staticRenderFns } from "./ai_catalog_mcp_server.vue.js?vue&type=template&id=07537698&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ai_catalog_mcp_server.vue?vue&type=template&id=07537698&vue3"
import script from "./ai_catalog_mcp_server.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ai_catalog_mcp_server.vue?vue&type=script&lang=js&vue3"
export * from "./ai_catalog_mcp_server.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ai_catalog_mcp_server.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports